<template>
  <form @submit.prevent="onSubmit">
    <b-row>
      <b-col class="mb-2 mb-md-0" cols="12" lg="7" md="9">
        <b-input-group>
          <b-input-group-prepend is-text>
            วันที่
          </b-input-group-prepend>

          <b-form-datepicker v-model="from" :max="to" required />

          <b-input-group-append is-text>
            ถึง
          </b-input-group-append>
          <b-form-datepicker v-model="to" :max="new Date()" required />

        </b-input-group>
      </b-col>
      <b-col class="text-right text-md-left" cols="12" lg="5" md="3">
        <b-button type="submit">
          ตกลง
        </b-button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'PaymentGatewayFilter',
  data() {
    return {
      from: new Date(),
      to: new Date(),
    }
  },
  watch: {
    to(val) {
      if (dayjs(val).isBefore(this.from)) {
        this.from = val;
      }
    }
  },
  methods: {
    onSubmit() {
      this.$emit('submit', {
        from: dayjs(this.from).toDate(),
        to: dayjs(this.to).toDate(),
      });
    }
  }
}
</script>